<template xmlns="http://www.w3.org/1999/html">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> All Templates
                    </div>
                    <div class="card-block">
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-6 pl-0">
                                    <button class="btn btn-primary" @click="createTemplate()">New template</button>
                                </div>
                                <div class="col-md-6 pr-0" style="display: inline-flex;">
                                    <div class="col-md-4 pr-0">
                                        <label class="form-control-label" style="padding-top: 7px;">Search template</label>
                                    </div>
                                    <div class="col-md-8 ml-0 pl-0 pr-0">
                                        <input v-model="search_value" class="form-control" type="search"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table class="table table-bordered table-striped table-condensed mt-1">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Number</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Document type</th>
                                <th>Contract type</th>
                                <th>Client title</th>
                                <th>Options</th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="templates.length" v-for="template in templates">
                                <td>{{template.id}}</td>
                                <td>{{template.contract_name}}</td>
                                <td>{{template.contract_number}}</td>
                                <td>{{template.contract_status}}</td>
                                <td>{{template.contract_date}}</td>
                                <td>{{template.document_type}}</td>
                                <td>{{template.contract_type}}</td>
                                <td>{{template.client_title}}</td>
                                <td>
                                    <i class="fa fa-edit fa-lg action" @click="editTemplate(template)" rel="tooltip" title="Edit template"></i>
                                    <i v-if="template.contract_type != 'imported'" class="fa fa-copy fa-lg action" @click="copyTemplate(template.id)" rel="tooltip" title="Copy template"></i>

                                    <button v-if="template.contract_type == 'system'" style="border: none; background-color: inherit;" class="fa fa-file-pdf-o fa-lg action"
                                      title="Print contract PDF" @click="download({newTab:true, url:'/api/print_template', params:{template_id:template.id}})"></button>

                                    <button v-if="template.contract_type == 'system'" style="border: none; background-color: inherit;" class="fa fa-file-word-o fa-lg action"
                                      title="Print contract Docx" @click="download({url:'/api/print_template_to_msword', params:{template_id:template.id}})"></button>

                                    <!--<form v-if="template.contract_type == 'imported'" style="display: inline;" action="/print_contract_imported" target="_blank">-->
                                        <!--<input type="hidden" name="contract_id" :value="contract.id">-->
                                        <!--<button style="border: none; background-color: inherit;" type="submit" class=" fa fa-file-pdf-o fa-lg action" rel="tooltip" title="Download contract"></button>-->
                                    <!--</form>-->
                                    <i class="fa fa-trash fa-lg action" @click="deleteTemplate(template)" rel="tooltip" title="Delete template"></i>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <template>
                            <v-page :setting="pageSet" @page-change="pageChange"></v-page>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import modal from 'vue-strap/src/Modal';
import VueNotifications from 'vue-notifications';
import vPage from '../libraries/vPage/vPage.vue';
import { Backend, download, filenameFilter } from '@/_axios';

export default {
  name: 'Templates',
  components: {
    modal,
    vPage
  },
  data() {
    return {
      download: download,
      filenameFilter: filenameFilter,
      pageSet: {
        totalRow: '',
        language: 'en',
        pageSizeMenu: [10, 20, 50, 100],
        pageNumber: 1,
        pageSize: 10,
        currentPage: ''
      },
      search_value: '',
      timeout_id: '',
      confirmation_options: {
        okText: 'Delete',
        cancelText: 'Cancel',
        verification: 'delete'
      }
    };
  },
  watch: {
    templates: function (val) {
      this.pageSet.totalRow = this.templates_count;
    },
    search_value: function (val) {
      this.pageSet.currentPage = 0;
      const vm = this;
      if (vm.timeout_id) {
        clearTimeout(vm.timeout_id);
      }
      vm.timeout_id = setTimeout(() => {
        vm.pageSet.currentPage = 1;
        vm.GET_TEMPLATES_LIST({ search_value: vm.search_value, pageNumber: 1, pageSize: vm.pageSet.pageSize });
      }, 1000);
    },
    deleted_template: function (val) {
      if (this.deleted_template.status == 'success') {
        this.showSuccessMsg({ title: 'Template delete status', message: `Template ${this.deleted_template.data.contract_name} deleted!` });
      }
      if (this.deleted_template.status == 'error') {
        this.showErrorMsg({ title: 'Template delete status', message: this.deleted_template.message });
      }
    },
    copied_template: function (val) {
      if (this.copied_template.status == 'success') {
        this.showSuccessMsg({ title: 'Template copy status', message: `Template ${this.copied_template.data.contract_name} copied!` });
      }
      if (this.copied_template.status == 'error') {
        this.showErrorMsg({ title: 'Template copy status', message: this.copied_template.message });
      }
    }
  },
  computed: {
    ...mapGetters('Templates', [
      'templates',
      'deleted_template',
      'copied_template',
      'templates_count'
    ])
  },
  methods: {
    ...mapActions('Templates', [
      'GET_TEMPLATES_LIST',
      'DELETE_TEMPLATE',
      'COPY_TEMPLATE'
    ]),
    pageChange(pInfo) {
      this.pageSet.pageNumber = pInfo.pageNumber;
      this.pageSet.pageSize = pInfo.pageSize;
      this.GET_TEMPLATES_LIST({ search_value: this.search_value, pageNumber: this.pageSet.pageNumber, pageSize: this.pageSet.pageSize });
      //                console.log(pInfo);//{pageNumber: 1, pageSize: 10}
    },
    deleteTemplate(template) {
      const vm = this;
      this.$dialog.confirm(`Delete template - ${template.contract_name}?`, this.confirmation_options)
        .then(() => {
          vm.DELETE_TEMPLATE(template.id);
        })
        .catch(() => {

        });
    },
    editTemplate(template) {
      this.$router.push({ name: 'EditTemplate', params: { id: template.id } });
    },
    copyTemplate(id) {
      this.COPY_TEMPLATE(id);
    },
    createTemplate() {
      this.$router.push({ name: 'NewTemplate' });
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.GET_TEMPLATES_LIST({ search_value: this.search_value, pageNumber: this.pageSet.pageNumber, pageSize: this.pageSet.pageSize });
  }
};
</script>

<style lang="scss" scope>
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }

    .dg-btn--ok {
        color: #fff;
        background-color: #20a8d8;
        border-color: #20a8d8;
        border-radius: var(--border-radius);
    }

    .dg-btn--ok:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #1985ac;
        border-color: #187fa3;

    }

    .dg-btn--ok:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--ok:disabled,
    .dg-btn--ok.is-disabled {
        opacity: .5;
    }

    .dg-btn--cancel {
        color: #263238;
        background-color: #fff;
        border-color: #b0bec5;
        border-radius: var(--border-radius);
    }

    .dg-btn--cancel:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #e6e5e5;
        border-color: #8da1ab;

    }

    .dg-btn--cancel:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--cancel:disabled,
    .dg-btn--cancel.is-disabled {
        opacity: .5;
    }
</style>
